import Swiper from 'swiper/js/swiper.js';

function initGallerySliders() {

	[].forEach.call( document.querySelectorAll( '.property-gallery' ), function( el ) {
		let track      = el.querySelector( '.swiper-container' );
		let pagination = el.querySelector( '.swiper-pagination' );

		let swiper = new Swiper( track, {
			init: true,
			loop: true,
			speed: 300,
			spaceBetween: 2,
			slidesPerView: 'auto',
			preloadImages: false,
			watchOverflow: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: pagination,
				type: 'bullets',
				bulletElement: 'button',
				dynamicBullets: true,
				clickable: true,
			},
		} );
	});
}

initGallerySliders();
// not sure this works? need to revisit
jQuery( document ).on( 'favorites-list-updated', initGallerySliders );

const recentProperties = new Swiper( '#testimonials-slider', {
	loop: true,
	speed: 300,
	preloadImages: false,
	centeredSlides: true,
	initialSlide: 1,
	spaceBetween: 20,
	slidesPerView: 1,
	autoplay: {
		delay: 3000,
	  },
} );

const testimonialsSlider = new Swiper( '#recent-properties', {
	loop: true,
	speed: 300,
	preloadImages: false,
	centeredSlides: true,
	initialSlide: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		bulletElement: 'button',
		clickable: true,
	},
	spaceBetween: 20,
	slidesPerView: 1,
	breakpoints: {
		480: {
			slidesPerView: 2,
		},
		1096: {
			slidesPerView: 3,
			spaceBetween: 40,
		},
		1230: {
			spaceBetween: 40,
			slidesPerView: 4,
		},
	}
} );


const propertyThumbs = new Swiper( '#thumbnails', {
	spaceBetween: 10,
	slidesPerView: 3,
	loop: false,
	watchSlidesVisibility: true,
	watchSlidesProgress: true,
	navigation: {
		nextEl: '.swiper-button-next-thumb',
		prevEl: '.swiper-button-prev-thumb',
	},
	breakpoints: {
		480: {
			slidesPerView: 4,
		},
		1096: {
			slidesPerView: 6,
		},
	}
} );

const propertyGallery = new Swiper( '#slider', {
	spaceBetween: 0,
	preloadImages: false,
	loop: false,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	thumbs: {
		swiper: propertyThumbs,
	},
} );
